exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cxxMH{position:fixed;top:0;left:0;right:0;bottom:0;z-index:2001;display:flex;align-items:center;justify-content:center;background-color:rgba(22,45,61,.8);opacity:0;transition:opacity .2s}.cxxMH._1hE8U{opacity:1}.goZu9{position:relative;overflow:hidden;width:495px;max-width:calc(100% - 60px);border-radius:8px;background:#fff;box-shadow:0 0 14px 0 rgba(29,45,60,.3)}._2gScv{padding:31px 30px 27px;color:#2b5672;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:16px;line-height:22px;font-weight:300}._2JmC7{display:flex;justify-content:flex-end;padding:0 24px 30px}.ATBl5{min-width:96px;height:30px;margin-left:18px;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px}._25Fxs{width:500px;height:555px}._1ZPGl{height:100%;padding:0}.gR0LB{border:none;border-radius:8px}.gR0LB,.w9Ipi{width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"modal": "cxxMH",
	"open": "_1hE8U",
	"window": "goZu9",
	"content": "_2gScv",
	"buttons": "_2JmC7",
	"button": "ATBl5",
	"iframe-modal-window": "_25Fxs",
	"iframeModalWindow": "_25Fxs",
	"iframe-modal-content": "_1ZPGl",
	"iframeModalContent": "_1ZPGl",
	"iframe": "gR0LB",
	"simple-modal-content": "w9Ipi",
	"simpleModalContent": "w9Ipi"
};